import { Box, Text, Tooltip } from "@chakra-ui/react"

type DocumentProductCellProps = {
  sku?: string | null
  name?: string | null
  layout?: "stacked" | "inline"
  separator?: string
}

export function buildDocumentProductLabel(
  sku?: string | null,
  name?: string | null,
  separator = " — ",
): string {
  const label = [sku ?? "", name ?? ""].filter(Boolean).join(separator).trim()
  return label || "—"
}

export default function DocumentProductCell({
  sku,
  name,
  layout = "stacked",
  separator = " — ",
}: DocumentProductCellProps) {
  const fullLabel = buildDocumentProductLabel(sku, name, separator)

  const content =
    layout === "inline" ? (
      <Box minW={0}>
        <Text noOfLines={1}>{fullLabel}</Text>
      </Box>
    ) : (
      <Box minW={0}>
        <Text fontWeight="medium" noOfLines={1}>
          {sku || "—"}
        </Text>
        <Text fontSize="sm" color="gray.500" noOfLines={1}>
          {name || "—"}
        </Text>
      </Box>
    )

  if (fullLabel === "—") {
    return content
  }

  return (
    <Tooltip label={fullLabel} hasArrow placement="top">
      {content}
    </Tooltip>
  )
}
